import { render, staticRenderFns } from "./ConfirmUserPanel.vue?vue&type=template&id=6e45862e&scoped=true"
import script from "./ConfirmUserPanel.vue?vue&type=script&lang=ts"
export * from "./ConfirmUserPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e45862e",
  null
  
)

export default component.exports